import MdnReducter from './MdnRedactor';
import TokenRedactor from './TokenRedactor';
import { IValueRedactor } from './IValueRedactor';

const redactors: IValueRedactor[] = [new MdnReducter(), new TokenRedactor()];

export default redactors;


// WEBPACK FOOTER //
// ./packages/platform-utils/logging/redactors/index.ts